import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import firebaseConfig from '../firebase-applet-config.json';

// Resolve authDomain: Use custom domain 'zipytiny.app' in production so Google Sign-In displays Zipytiny.app,
// and fall back to the default firebaseapp.com domain in preview and development environments.
const resolvedConfig = { ...firebaseConfig };

if (typeof window !== 'undefined') {
  const host = window.location.hostname.toLowerCase();
  if (host === 'zipytiny.app' || host === 'www.zipytiny.app') {
    resolvedConfig.authDomain = 'zipytiny.app';
  } else {
    resolvedConfig.authDomain = firebaseConfig.authDomain;
  }
} else {
  resolvedConfig.authDomain = firebaseConfig.authDomain;
}

const app = initializeApp(resolvedConfig);
export const db = getFirestore(app, resolvedConfig.firestoreDatabaseId);
export const auth = getAuth(app);
